<template>
  <ProfileMenuHeader
    :full-name="fullName"
    :company="company"
    :role-label="roleLabel"
    :is-mobile="isMobile"
    @edit="$emit('navigate', '/profile')"
    @close="$emit('close')"
  />

  <div class="w-full h-0 border-t border-[#e0e3e5]" />

  <ProfileMenuDevicesSection
    v-if="isMobile"
    @close-menu="$emit('close')"
  />

  <Divider
    v-if="isMobile"
    class="!my-0"
  />

  <ProfileMenuItem
    v-if="!isMobile"
    icon="pi-user"
    :title="$t('profile.user_profile')"
    :subtitle="$t('profile.edit_your_profile')"
    @click="$emit('navigate', '/profile')"
    @keydown.enter="$emit('navigate', '/profile')"
  />

  <ProfileMenuItem
    v-if="hasAdminAccess && !isMobile"
    icon="pi-id-card"
    :title="$t('admin.title')"
    :subtitle="$t('admin.manage_org')"
    @click="$emit('navigate', '/admin')"
    @keydown.enter="$emit('navigate', '/admin')"
  />

  <!-- UV2: on a phone the sidebar is hidden, so every section is offered here. -->
  <template v-if="isMobile">
    <ProfileMenuItem
      v-for="section in adminSections"
      :key="section.to"
      data-testid="admin-section"
      :icon="section.icon"
      :title="$t(section.labelKey)"
      @click="$emit('navigate', section.to)"
      @keydown.enter="$emit('navigate', section.to)"
    />
  </template>

  <ProfileMenuItem
    icon="pi-cog"
    :title="$t('settings.settings')"
    :subtitle="$t('settings.app_settings')"
    @click="$emit('navigate', '/settings')"
    @keydown.enter="$emit('navigate', '/settings')"
  />

  <ProfileMenuItem
    v-if="isMobile"
    icon="pi-question-circle"
    :title="$t('settings.help')"
    :subtitle="$t('settings.help_details')"
    @click="$emit('navigate', '/help')"
    @keydown.enter="$emit('navigate', '/help')"
  />

  <div class="w-full h-0 mt-auto md:border-t md:border-[#e0e3e5]" />

  <button
    type="button"
    class="box-border w-full flex flex-row justify-center items-center px-4 py-2 h-10 bg-transparent border border-[#7190a6] rounded-md font-normal text-sm leading-[17px] text-center text-[#7190a6] cursor-pointer transition-colors duration-150 hover:bg-[#eef2f4] focus-visible:bg-[#eef2f4] focus-visible:outline-none"
    @click="$emit('logout')"
  >
    {{ $t('profile.logout') }}
  </button>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { AdminSection } from '@/composables/useAdminSections';
import Divider from 'primevue/divider';
import ProfileMenuHeader from '@/components/header/ProfileMenuHeader.vue';
import ProfileMenuItem from '@/components/header/ProfileMenuItem.vue';
import ProfileMenuDevicesSection from '@/components/header/ProfileMenuDevicesSection.vue';

export default defineComponent({
  name: 'ProfileMenuPanel',
  components: {
    Divider,
    ProfileMenuHeader,
    ProfileMenuItem,
    ProfileMenuDevicesSection,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    hasAdminAccess: {
      type: Boolean,
      default: false,
    },
    adminSections: {
      type: Array as PropType<AdminSection[]>,
      default: () => [],
    },
    fullName: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    roleLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['navigate', 'logout', 'close'],
});
</script>
